module.exports = __webpack_public_path__ + "img/Group 2981.43515fe7.png";